import { mockResponse, request, isMockMode } from './client.js';
import { PRODUCTS } from '../data/products.js';
import { ORDERS } from '../data/orders.js';

/**
 * 後台儀表板統計。
 *
 * 為什麼合在一個 endpoint？
 *   儀表板首屏需要多個指標。如果每個都打 API，會發出多個請求拖慢首屏。
 *   後端在一支 endpoint 內把所有聚合算好回傳。
 *
 * 對應 API: GET /api/admin/dashboard/stats
 * DashboardStatsDto：{ totalRevenue, monthRevenue, totalOrders, pendingOrders,
 *   totalProducts, totalMembers, newMembersThisMonth, recentOrders:[OrderDto] }
 * 營業額只算已成交狀態（processing/shipping/delivered），待處理 = pending。
 */
export function getDashboardStats() {
  if (!isMockMode('dashboard')) return request('/api/admin/dashboard/stats');
  return mockResponse(() => {
    // mock：營業額只算已成交狀態、待處理算 pending，與後端對齊
    const paid = ORDERS.filter(o => ['processing', 'shipping', 'delivered'].includes(o.status));
    const totalRevenue = paid.reduce((s, o) => s + o.total, 0);
    const pendingOrders = ORDERS.filter(o => o.status === 'pending').length;

    return {
      totalRevenue,
      monthRevenue: Math.floor(totalRevenue * 0.42),
      totalOrders: ORDERS.length,
      pendingOrders,
      totalProducts: PRODUCTS.length,
      totalMembers: 1842,
      newMembersThisMonth: 89,
      recentOrders: ORDERS.slice(0, 5),
    };
  });
}
